
	import {
		Vue,
		Component
	} from 'vue-property-decorator'

	import ConInfo from './newuser-equip'
	import OutBm from './equip-out'
	import SetSize from './set-size'
	// import fa from "element-ui/src/locale/lang/fa";
	@Component({
		name: 'contractinfo',
		components:{
			ConInfo,
			OutBm,
			SetSize
		}
	})
	export default class newuserConfig extends Vue {
		customerVisible=false
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		childDept = [];
		activeNames=[];
		customerUserVisible = false
		showbmxxVisible: boolean = false;
		customerList=[]
		showfileVisible=false
		showInfoVisible=false
		setSizeVisible=false
		showInfoVisible2=false
		types=[]
		form={
			dept:'',
			childDept: '',
			name:'',
			isleave:0,
			gw:''
		}
		startTime=[]
		endTime=[]
		childdeptdisable=false
		deptdisable =false
		amount=['','']
		contractList=[]
		batchVisible = false
		bmxx=[]
		loading: boolean = false;
		dataListSelections=[];
		sjbm=[]
		depts=[]
		selectBm=''
		created() {
			this.getDepts()
			this.getbmxx()
		}

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.getUserList();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.getUserList();
		}

		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		showInfo(row){

			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showInfo.init(row.id)
			})
		}
		setSize(row){

			this.setSizeVisible = true
			var data = {userid: '',
				uniformsaSize:'',
				uniformsSize:'',
				uniformwSize:'',
				shoseSize: '',
				hatSize: ''}
				data.userid = row.id
				data.uniformsaSize = row.uniformsaSize
				data.uniformsSize = row.uniformsSize
				data.uniformwSize = row.uniformwSize
				data.shoseSize = row.shoseSize
				data.hatSize = row.hatSize
			this.$nextTick(() => {
				this.$refs.setSize.init(data)
			})
		}
		updateNeedEquip(id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			this.$confirm(`确定进行不发装备操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: '/bjba/equip/out/updateNeedEquip',
					data:ids,
					method: 'post'
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message
						({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.getUserList()
					} else if(data && data.code ==500) {
						this.$message
						({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
		out(row){

			this.showInfoVisible2 = true
			this.$nextTick(() => {
				this.$refs.showInfo2.init(row.id,1)
			})
		}
		batchOut() {
			this.batchVisible = true
			this.$nextTick(() => {
				this.$refs.batchin.init()
			})
		}
		addOrUpdate(val: any) {

			if(!this.dataListSelections|| this.dataListSelections.length==0) {
				this.$message.warning("请选择装备")
				return
			}
			let ids = this.dataListSelections.map(item => {
				return item.id
			})
			this.customerVisible = true
			this.$nextTick(() => {
				this.$refs.customer.init(ids)
			})
		}

		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
				if(this.depts && this.depts[0]) {
					var zzdyqc = this.$store.getters.user.zzdyqc;
					if(zzdyqc != this.CONST_ZN_BM) {
						var zw = this.$store.getters.user.zw;

						if(zw) {
							if(zw=='01'||zw=='02'||zw=='03') {
								this.form.dept = that.depts[0].bmid
								this.deptdisable = true
								if(zw !='01') {
									this.childdeptdisable =true;
								}
								this.selectChanged2(this.form.dept)
							}
							this.selectChanged2(this.form.dept)
						} else {this.selectChanged2(this.form.dept)}

					} else {  this.selectChanged2(this.form.dept)}
				}
			})
		}
		getbmxx() {
			let that = this;
			this.$request.get('/bjba/yhgl/getbmxx').then(res => {
				console.log("bmxx:", res);
				that.bmxx = res.data;
			})
		}
		showUser(user) {
			this.$router.push({
				path: "/bjba/grzx",
				query: { username: user.username },
			});
		}
		getBm(user) {
			var ubmid ;
			if(user.ddbz)  ubmid= user.ddbz;
			else ubmid = user.zzdyqc
			for(var i=0; i<this.bmxx.length;i++) {

				if(this.bmxx[i].bmid == ubmid) {
					return this.bmxx[i].bmmc
				}
			}
		}
		selectChanged2(value) {
			this.currentNo = 1
			this.childDept = []
			this.form.childDept =''
			this.$request({
				method: 'get',
				url: '/bjba/kqtj/getMentForUser2',
				params: {
					fbmid: value,
					userid:this.$store.getters.username
				}
			}).then((response) => {

				this.childDept = response.data;
				var zzdyqc = this.$store.getters.user.zzdyqc;
				if(zzdyqc != this.CONST_ZN_BM) {
					var zw = this.$store.getters.user.zw;
					if(zw) {
						if(zw=='02'||zw=='03') {
							if(this.childDept[0]) {
								this.form.childDept = this.childDept[0].bmid

							}
						}
					}
				}
				this.getUserList();
			}).catch((err) => {
				console.log(err)
			})
		}
		selectChanged3(value) {
			this.currentNo = 1;
			this.getUserList();


		}
		getUserList () {
			this.loading = true
			this.form.page = this.currentNo;
			this.form.pagesize = 10
			this.form.userid = this.$store.getters.username
			this.$request.get('/bjba/yhgl/getNoneEquipUsers', {
				params: this.form
			}).then(res => {
				const {
					data
				} = res
				console.log("列表数据：", data)
				this.contractList = data.data.content
				this.pageTotal = data.data.totalElements
				this.loading = false
			}).catch(err => {
				this.$message({
					message: '获取用户列表出现异常!',
					type: 'error',
					center: true,
					showClose: true
				})
				this.loading = false
				console.log(err)
			})
		}
	}
